import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import moment from "moment";

// 船員マスターリポジトリ
const enterpriseCrewRepositoryV2 = AiseaApiFactory.get("enterpriseCrew_v2");

/**
 * 船員マスタサービス
 */
const EnterpriseCrewsService = (() => {
  let _enterpriseCrews = null;

  const fetch = async () => {
    const payload = {
      details: [
        "CREW_AVAILABLE_ROLE",
        "CREW_FISCAL_YEARS",
        "CREW_LICENSE",
        "CREW_RESPONSIBILITY",
      ],
    };
    const res = await enterpriseCrewRepositoryV2.fetch(payload);
    if (!res || !res.status) {
      throw res;
    }
    _enterpriseCrews = res.data;
    return _enterpriseCrews;
  };

  const clear = () => {
    _enterpriseCrews = null;
  };

  const findById = id => {
    if (!_enterpriseCrews) {
      return null;
    }

    return _enterpriseCrews.crews.find(crew => crew.id === id) || null;
  };

  /**
   *  船員の会計年度ごとの基本乗船期間日数を取得します。
   * @param {String} crewId 船員ID
   * @param {Number} fiscalYear 会計年度
   * @returns {Number|null} 基本乗船期間日数
   * 取得できない場合はnullを返します。
   */
  const getBasicBoardingDaysByFiscalYear = (crewId, fiscalYear) => {
    if (!_enterpriseCrews) {
      return null;
    }
    const crew = findById(crewId);
    if (!crew || !crew.crew_fiscal_years) {
      return null;
    }

    const fiscalYearData = crew.crew_fiscal_years.find(
      year => year.fiscal_year === fiscalYear
    );
    if (!fiscalYearData || !fiscalYearData.basic_boarding_days) {
      return null;
    }

    return fiscalYearData.basic_boarding_days || null;
  };

  /**
   * 日付から船員の辞令職を取得する。
   * @param {Object} crew
   * @param {Date} date
   * @returns {Object|null} 辞令職情報
   */
  const findAppointmentRoleByDate = (crew, date) => {
    if (!crew || !crew.crew_available_roles) {
      return null;
    }

    const dateFmt = "YYYY-MM-DD";
    const mdate = moment(date);

    const appointemntRoles = crew.crew_available_roles
      .filter(role => {
        return role.is_appointed;
      })
      .map(role => {
        return {
          start_date: moment(role.start_date, dateFmt),
          enterprise_crew_role_id: role.enterprise_crew_role_id,
        };
      });

    if (appointemntRoles.length === 0) {
      return null;
    }
    // 役職の開始日で降順ソート
    appointemntRoles.sort((a, b) => {
      return a.start_date.isBefore(b.start_date) ? -1 : 1;
    });

    // 指定日以降の役職を取得
    return appointemntRoles.find(role => {
      return role.start_date.isSameOrBefore(mdate);
    });
  };

  /**
   * 船員の辞令職を取得する。
   * 辞令職が複数ある場合は、最初のものを返します。
   * @param {Object} crew
   * @returns {Object|null} 辞令職情報
   */
  const findAppointmentRoleFirst = crew => {
    if (!crew || !crew.crew_available_roles) {
      return null;
    }

    return crew.crew_available_roles.find(role => {
      return role.is_appointed;
    });
  };

  return {
    fetch,
    clear,
    findById,
    getBasicBoardingDaysByFiscalYear,
    findAppointmentRoleByDate,
    findAppointmentRoleFirst,
  };
})();

export default EnterpriseCrewsService;
